module.exports = __webpack_public_path__ + "img/avatar0.659453bb.png";